import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs, DataSourceChangedEventArgs } from '@syncfusion/ej2-angular-grids';
import { HttpBackend, HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { LocalStorageService } from '../localStorage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SoftwarelistService extends Subject<DataStateChangeEventArgs>  {
  private httpClient: HttpClient;
  constructor(private handler: HttpBackend, private http: HttpClient, private storageService: LocalStorageService) {
    super();
    this.httpClient = new HttpClient(handler);

   }
  
   handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
  //  window.alert(errorMessage);
  console.log("Error:",errorMessage);
    return throwError(errorMessage);
  }


  // Create softwares
  createSoftwares(user: Object): Observable<Object> {
    console.log("In createSoftwares method, Softwares: ", user);
    return this.http.post(`${environment.apiUrl}/softwares`, user).pipe(catchError(this.handleError));
  }

   // Get softwares by Id Get
   getSoftwares(id: number): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/softwares/${id}`).pipe(catchError(this.handleError));
  }

  //Delete softwares by Id Delete
  deleteSoftwares(id: number): Observable<Object> {
    return this.http.delete(`${environment.apiUrl}/softwares/${id}`).pipe(catchError(this.handleError));
  }

  //Update softwares by Id Put
  updateSoftwares(user: Object,id: number): Observable<Object> {
    console.log("In createUser method, user: ", user);
    return this.http.put(`${environment.apiUrl}/softwares/${id}`, user).pipe(catchError(this.handleError));
  }

   //Get All Contact by Id Get
   getAllSoftwares(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/softwares`).pipe(catchError(this.handleError));
  }

  uploadImage(id: number, data: any): Observable<Object> {
    const header = {
      headers: new HttpHeaders({
        'Authorization': this.storageService.get('token'),
        'tenantId': this.storageService.get('tenantId'),
      }),
    };
    return this.httpClient.post(`${environment.apiUrl}/softwares/` + id + `/attachments`, data, header).pipe(catchError(this.handleError));
  }

  getslApplicationsattachments(Id: number): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/softwares/${Id}/attachments`).pipe(catchError(this.handleError));
  }

  deleteslApplicationsattachments(slId: any, imageid: number): Observable<Object> {
    return this.http.delete(`${environment.apiUrl}/softwares/${slId}/attachments/${imageid}`).pipe(catchError(this.handleError));
  }

  downloadslApplicationsattachments(slId: any, imageid: number): Observable<Object> {
    const header = {
      headers: new HttpHeaders({
        'Authorization': this.storageService.get('token'),
        'tenantId': this.storageService.get('tenantId'),
      }),
    };
    return this.http.get(`${environment.apiUrl}/softwares/${slId}/attachments/${imageid}`).pipe(catchError(this.handleError));
  }

}
